import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colourWhite, colourMasterLight } from 'Styles/colors.css';
import { UI } from 'SharedConstants/';
import { SELECTED_CONTAINER, SETTINGS_PANEL_WIDTH } from 'PreviewConstants/';
import { getAdId } from 'Selectors';
import { getActivePageLayout, getURLSafeLayoutName } from 'PreviewSelectors';
import { imageToBlob } from 'Shared/utils/utils';

import LayoutRecord from 'PreviewRecords/LayoutRecord';
import WveStyleElementLabel from 'Components/WveSettingsPanel/WveStyleElement/WveStyleElementLabel/WveStyleElementLabel';
import WveLinkButton from 'SharedComponents/WveInputs/WveLinkButton/WveLinkButton';

const Container = styled.div`
    position: fixed;
    margin-bottom: 0;
    z-index: 500;
    border-left: 1px solid ${colourMasterLight};
    width: ${SETTINGS_PANEL_WIDTH}px;
    right: -${SETTINGS_PANEL_WIDTH}px;
    bottom: 0px;
    top: 0px;
    background-color: ${colourWhite}
`;

const ActionButtonsContainer = styled.div`
  position: absolute;
  display: flex;
  right: 0;
  margin: 6px;
  margin-top: 0;
`;

const PanelContents = styled.div`
  position: relative;
`;

const QRCode = styled.img`
  display: block;
  position: relative;
  width: 125px;
  height: auto;
  margin-top: 10px;
`;

const PreviewLink = styled.pre`
  width: 100%;
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(0, 0, 0, 0.07);
  background-color: #fafafa;
  font-family: Menlo,Monaco,Consolas,"Courier New",monospace;
  font-size: 13px;
  height: auto;
  padding: 8px 9px;
  margin-top: 5px;
  white-space: pre-line;
`;

class SharingPanel extends Component {
  handleCopyLinkToClipboard = (event) => {
    event.stopPropagation();
    const elm = event.target.parentNode.parentNode.querySelector('pre');
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(elm);
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('Copy');
    selection.removeAllRanges();
  }
  handleCopyQRToClipboard = async (event) => {
    event.stopPropagation();
    const elm = event.target.parentNode.parentNode.querySelector('img');
    const imageData = await imageToBlob(elm.src);
    await navigator.clipboard.write([
      // eslint-disable-next-line no-undef
      new ClipboardItem({ 'image/png': imageData }),
    ]);
  }
  render() {
    const { adId, activeLayout, selectedContainer } = this.props;
    const safeName = activeLayout ? getURLSafeLayoutName(activeLayout.name) : '';
    const previewPath = (selectedContainer === 'responsive') ? selectedContainer : `${selectedContainer}/${safeName}`;

    return (
      <PanelContents>
        <div style={{ paddingLeft: '15px', marginTop: '10px' }} >
          <ActionButtonsContainer>
            <WveLinkButton handleClick={this.handleCopyLinkToClipboard} >
              {'Copy to clipboard'}
            </WveLinkButton>
          </ActionButtonsContainer>
          <WveStyleElementLabel
            key=""
            label="Link"
          />
          <PreviewLink>{`https://${location.hostname}${location.pathname}?${previewPath}`}</PreviewLink>
        </div>
        <div style={{ paddingLeft: '15px' }} >
          <ActionButtonsContainer>
            <WveLinkButton handleClick={this.handleCopyQRToClipboard} >
              {'Copy QR to clipboard'}
            </WveLinkButton>
          </ActionButtonsContainer>
          <WveStyleElementLabel
            key=""
            label="QR Code"
          />
          <QRCode src={`/build/ads/${adId}/preview_qr?${previewPath}`} />
        </div>
      </PanelContents>);
  }
}

// export default SideBar;

SharingPanel.propTypes = {
  adId: PropTypes.number,
  activeLayout: PropTypes.instanceOf(LayoutRecord),
  selectedContainer: PropTypes.string,
};

SharingPanel.defaultProps = {
  adId: null,
  activeLayout: null,
  selectedContainer: 'standard',
};

const mapStateToProps = state => ({
  adId: getAdId(state),
  activeLayout: getActivePageLayout(state),
  selectedContainer: state.getIn([UI, SELECTED_CONTAINER]),
});

export default connect(mapStateToProps, null)(SharingPanel);



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/Panels/SharingPanel.jsx